import React from "react";
import { ToggleWrapper, Thumb } from "./toggle-style";

interface IToggleProps {
  checked: boolean;
  onChange?: () => void;
  disabled?: boolean;
}

export const Toggle: React.FC<IToggleProps> = ({
  checked,
  onChange,
  disabled = false
}) => {
  return (
    <ToggleWrapper
      checked={checked}
      disabled={disabled}
      onClick={disabled ? undefined : onChange}
      aria-pressed={checked}
      aria-disabled={disabled}
    >
      <Thumb checked={checked} />
    </ToggleWrapper>
  );
};
